// extracted by mini-css-extract-plugin
module.exports = {"mainColumn":"side-column-layout-module--mainColumn--oUAp2","container":"side-column-layout-module--container--9czdO","sideColumn":"side-column-layout-module--sideColumn--3CLhC"};